import { Button } from "components/Button/Button";
import Link from "components/DelayedLink";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { Popover } from "components/Popover/Popover";
import StatusBadge from "components/StatusBadge";
import { TimeAgo } from "components/TimeAgo/TimeAgo";
import { messagesTab } from "containers/AdvancedSearch/constants";
import { setAdvancedSearchTab } from "containers/ExecutionFilter/filterStorage";
import {
    getSubmittedMessagesCount,
    getSubmittedMessagesList,
    getUnsubmittedMessagesCount,
    getUnsubmittedMessagesList,
} from "containers/Messages/Messages.selectors";
import { WebsocketMessage } from "graphql/message";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { mapScreensToPaths } from "utils/RouterManager/utils";
import { getRelativeUrl } from "utils/service";
import "./MessagesPopover.scss";
export const MessagesPopover = () => {
    const history = useHistory();

    const submittedMessages: WebsocketMessage[] = useSelector(getSubmittedMessagesList).slice(
        0,
        10
    );
    const unsubmittedMessages: WebsocketMessage[] = useSelector(getUnsubmittedMessagesList).slice(
        0,
        10
    );
    const submittedCount: number = useSelector(getSubmittedMessagesCount);
    const unsubmittedCount: number = useSelector(getUnsubmittedMessagesCount);

    const openButton = (
        <>
            <Icon icon={IconCollection.bellOutline} />
            {unsubmittedCount > 0 ? (
                <StatusBadge
                    round
                    text={unsubmittedCount >= 10 ? "9+" : String(unsubmittedCount)}
                    type="primary-blue"
                />
            ) : null}
        </>
    );

    const onAllMessagesClick = useCallback(() => {
        setAdvancedSearchTab(messagesTab);
        history.push(mapScreensToPaths.advancedSearch);
    }, [history]);

    const getMessageListComponent = (messages: WebsocketMessage[], is_submitted: boolean) => {
        return (
            <>
                <ul>
                    {messages.map((message) => (
                        <li
                            className={`message ${is_submitted ? "is-submitted" : ""}`}
                            key={message.id}
                        >
                            <Link to={getRelativeUrl("message", message?.id)}>
                                <Icon icon={IconCollection.bellOutline} />
                                <p className="text-sm text-secondary leading-loose">
                                    {message.subject}
                                </p>
                                <span className="text-dark-grey text-sm">
                                    <TimeAgo datetime={message.created_at} />
                                </span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </>
        );
    };

    return (
        <Popover
            trigger={openButton}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: 70,
            }}
            transformOrigin={{
                vertical: -14,
                horizontal: "right",
            }}
            toggleClassName="message-list__toggle"
            contentClassName="message-list"
            rootClassName="topbarPopover"
        >
            {unsubmittedCount > 0 ? (
                <>
                    <span className="message-list__label text-xs text-uppercase">
                        Latest unsubmitted messages
                    </span>
                    {getMessageListComponent(unsubmittedMessages, false)}
                </>
            ) : null}
            {submittedCount > 0 ? (
                <>
                    <span className="message-list__label text-xs text-uppercase">
                        Latest submitted messages
                    </span>
                    {getMessageListComponent(submittedMessages, true)}
                </>
            ) : null}
            {submittedCount + unsubmittedCount <= 0 ? (
                <p>No messages</p>
            ) : (
                <div className="message-button__container">
                    <Button onClick={onAllMessagesClick} variation="primary" label="All Messages" />
                </div>
            )}
        </Popover>
    );
};
